// Firebase
import firebase from 'firebase/app';
import 'firebase/auth';

// Firebase Init
const configOptions = {
	apiKey: 'AIzaSyANBtfdSOCmt7EgZBp4J22HyFrznms6ESY',
	authDomain: 'league-manager-5dba9.firebaseapp.com',
	databaseURL: 'https://league-manager-5dba9.firebaseio.com',
	projectId: 'league-manager-5dba9',
	storageBucket: 'league-manager-5dba9.appspot.com',
	messagingSenderId: '623379036409',
	appId: '1:623379036409:web:c5e6c233b0bb0cde02ca28',
};

firebase.initializeApp(configOptions);
